module.exports = __webpack_public_path__ + "img/kommune-1850.2e9d013b.svg";